import React from "react";
import { Helmet } from "react-helmet-async";

const PublicRouter = ({ children, title }) => {
    return (
        <>
            {title && (
                <Helmet>
                    <title>{`${title} - AgentUI`}</title>
                </Helmet>
            )}
            {children}
        </>
    );
};

export default PublicRouter;
